/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Custom hook for accessing the Analytics Context.
 *
 * --- REWRITE SUMMARY (Lint Fix) ---
 * - UPDATED: The import path for `AnalyticsContext` now points to the new,
 * dedicated context file at `../context/analytics.context.js`.
 */
import { useContext } from 'react';
import { AnalyticsContext } from '../context/analytics.context.js'; // <-- UPDATED IMPORT

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
